import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[mapSidePanelItemHost]',
    standalone: false
})
export class MapSidePanelItemHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
